import PropTypes from 'prop-types';
import { useRouter } from 'next/router';
import { gql, useMutation } from '@apollo/client';
import { checkIfLoggedIn, handleRefresh } from '@blaze-cms/core-auth-ui';

const REFRESH_USER_ACCESS = gql`
  mutation {
    resetUserAccessGroups {
      result
    }
  }
`;

const UserAccessRefresh = ({ resetQueryString }) => {
  const router = useRouter();

  const [mutateFunction, { data, loading, client }] = useMutation(REFRESH_USER_ACCESS, {
    onCompleted: async () => {
      await handleRefresh(null, client);
      window.location.href = router.asPath.replace(resetQueryString, '');
    }
  });

  if (loading || !resetQueryString || !router.asPath.includes(resetQueryString)) return null;

  const { isLoggedIn } = checkIfLoggedIn();

  if (isLoggedIn && !data) return mutateFunction();

  return null;
};

UserAccessRefresh.propTypes = {
  entity: PropTypes.string.isRequired,
  prefix: PropTypes.string,
  title: PropTypes.string,
  articleId: PropTypes.string,
  brokerId: PropTypes.string,
  exhibitorId: PropTypes.string,
  pageId: PropTypes.string,
  podcastId: PropTypes.string,
  profileId: PropTypes.string,
  yachtPageId: PropTypes.string,
  yachtForCharterId: PropTypes.string,
  yachtForSaleId: PropTypes.string
};

export default UserAccessRefresh;
